module.exports = __webpack_public_path__ + "static/slider-img-1-534e184619131515698e245c7f924372.jpg";